import { useIxmUserauthV1RealmQueryServiceRealmGet } from '@interxfi/api-client/generated/hooks/ixm-userauth-v1-realm-query-service-realm-get';
import { getShortenedId } from '@interxfi/design-system/components/format/id/shared';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';

interface RealmBreadcrumbProps {
  realmId: string;
}

export function RealmBreadcrumb({ realmId }: RealmBreadcrumbProps) {
  const { data, isPending } = useIxmUserauthV1RealmQueryServiceRealmGet({ realmId });

  if (isPending) {
    return <Skeleton charCount={12} />;
  }

  return data?.realm?.data?.spec?.name || `Realm ${getShortenedId(realmId)}`;
}
